<div class="header">
    <div class="header-top">
        <div class="container">
            <div class="col-sm-6 header-logo">
                <a class="navbar-brand"  routerLink="landing" href="#">
                    <img src="../../../../../../assets/images/logo1.png" alt="" class="">
                </a>
            </div> 
            <app-logout></app-logout>               
        </div>
    </div>
    <app-menus (selectedmenu)="onNavigation($event)"></app-menus>
   

</div>